import apiWorker from '../apiWorker'

const form_answers =  {
    find  : (company_id, form_id, contact_id) => apiWorker('get',   `/v1/api/form_answers/${company_id}/${form_id}/${contact_id}`, null, true),
    save  : (data)                            => apiWorker('post',   `/v1/api/form_answers/save`, data, true),
}

export default form_answers;